import {ALERT_SHOW} from "@/store/actions/alert";

import smsSendTemplateAPI from "@/utils/axios/sms_send_template"
import {
    CREATE_SMS_SEND_TEMPLATE,
    DELETE_SMS_SEND_TEMPLATE,
    GET_ALL_SMS_SEND_TEMPLATE,
    SELECT_SMS_SEND_TEMPLATE,
    UPDATE_SMS_SEND_TEMPLATE
} from "@/store/actions/sms_send_template";
import {START_MODAL_LOADING, STOP_MODAL_LOADING} from "@/store/actions/loading";

const state = { sms_send_templates: [], select_sms_send_templates: [], select_loaded: false }

const getters = {
    getSmsSendTemplates: state => state.sms_send_templates,
    getSelectSmsSendTemplates: state => state.select_sms_send_templates,
}

const actions = {
    [GET_ALL_SMS_SEND_TEMPLATE]: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            smsSendTemplateAPI.get_all(payload)
                .then(response => response.data)
                .then(data => {
                    commit(GET_ALL_SMS_SEND_TEMPLATE, data)
                    resolve(true)
                })
                .catch(err => {
                    const error = err.response.data.detail;
                    commit(ALERT_SHOW, { text: error, color: 'error lighten-1' })
                    reject(false)
                })
        })
    },
    [CREATE_SMS_SEND_TEMPLATE]: ({ dispatch, commit }, payload) => {
        return new Promise((resolve, reject) => {
            commit(START_MODAL_LOADING)
            smsSendTemplateAPI.create(payload)
                .then(response => response.data)
                .then(data => {
                    commit(CREATE_SMS_SEND_TEMPLATE, data)
                    dispatch(SELECT_SMS_SEND_TEMPLATE)
                    resolve(true)
                })
                .catch(err => {
                    const error = err.response.data.detail;
                    commit(ALERT_SHOW, { text: error, color: 'error lighten-1' })
                    reject(false)
                })
                .finally(() => commit(STOP_MODAL_LOADING))
        })
    },
    [UPDATE_SMS_SEND_TEMPLATE]: ({ commit }, payload) => {
        commit(START_MODAL_LOADING)
        return new Promise((resolve, reject) => {
            smsSendTemplateAPI.update(payload)
                .then(response => response.data)
                .then(data => {
                    commit(UPDATE_SMS_SEND_TEMPLATE, data)
                    resolve(true)
                })
                .catch(err => {
                    const error = err.response.data.detail;
                    commit(ALERT_SHOW, { text: error, color: 'error lighten-1' })
                    reject(false)
                })
                .finally(() => commit(STOP_MODAL_LOADING))
        })
    },
    [DELETE_SMS_SEND_TEMPLATE]: ({ dispatch, commit }, payload) => {
        return new Promise((resolve, reject) => {
            commit(START_MODAL_LOADING)
            smsSendTemplateAPI.remove(payload)
                .then(response => response.data)
                .then(data => {
                    commit(DELETE_SMS_SEND_TEMPLATE, data)
                    dispatch(SELECT_SMS_SEND_TEMPLATE)
                    resolve(true)
                })
                .catch(err => {
                    const error = err.response.data.detail;
                    commit(ALERT_SHOW, { text: error, color: 'error lighten-1' })
                    reject(false)
                })
                .finally(() => commit(STOP_MODAL_LOADING))
        })
    },
    [SELECT_SMS_SEND_TEMPLATE]: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            smsSendTemplateAPI.select(payload)
                .then(response => response.data)
                .then(data => {
                    commit(SELECT_SMS_SEND_TEMPLATE, data)
                    resolve(true)
                })
                .catch(err => {
                    const error = err.response.data.detail;
                    commit(ALERT_SHOW, { text: error, color: 'error lighten-1' })
                    reject(false)
                })
        })
    },
}

const mutations = {
    [GET_ALL_SMS_SEND_TEMPLATE]: (state, payload) => {
        state.sms_send_templates = payload
    },
    [CREATE_SMS_SEND_TEMPLATE]: (state, payload) => {
        state.sms_send_templates.push(payload)
    },
    [UPDATE_SMS_SEND_TEMPLATE]: (state, payload) => {
        let obj = state.sms_send_templates.find(item => item.id === payload.id)
        Object.keys(payload).forEach(item => {
            obj[item] = payload[item]
        })
    },
    [DELETE_SMS_SEND_TEMPLATE]: (state, payload) => {
        const obg = state.sms_send_templates.find(item => item.id === payload.id)
        const obj_id = state.sms_send_templates.indexOf(obg)
        if (obg) {
            state.sms_send_templates.splice(obj_id, 1)
        }
    },
    [SELECT_SMS_SEND_TEMPLATE]: (state, payload) => {
        state.select_sms_send_templates = payload
        state.select_loaded = true
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}